import { z } from "zod";
const sha = z.string().regex(/^[0-9a-f]{7,64}$/u);
const target = z.string().regex(/^[a-z0-9][a-z0-9-]*$/u);
const manifestHash = z.string().regex(/^[0-9a-f]{64}$/u);
export const candidateComponentBuildAttestationSchema = z.object({
    kind: z.literal("bundle_release_v1"),
    component: z.enum(["worker", "electric_runtime"]),
    releaseSha: sha,
    targetName: target,
    executionLane: z.string().regex(/^candidate:[0-9a-f]{7,64}$/u),
    manifestSha256: manifestHash,
    deployedAtMs: z.number().int().nonnegative(),
}).strict();
const releaseKeys = new Set(["sha", "branch", "dirty", "target", "deployed_at", "deployed_by"]);
export function parseCandidateComponentReleaseManifest(input) {
    const values = new Map();
    for (const line of input.manifestText.split(/\r?\n/u)) {
        if (!line)
            continue;
        const separator = line.indexOf("=");
        const key = line.slice(0, separator);
        const value = line.slice(separator + 1);
        if (separator <= 0 || !releaseKeys.has(key) || values.has(key) || !value) {
            throw new Error("Candidate component RELEASE manifest is malformed.");
        }
        values.set(key, value);
    }
    if (values.size !== releaseKeys.size || values.get("dirty") !== "false") {
        throw new Error("Candidate component RELEASE manifest is incomplete or dirty.");
    }
    const releaseSha = values.get("sha");
    const targetName = values.get("target");
    const deployedAtMs = Date.parse(values.get("deployed_at"));
    const parsed = candidateComponentBuildAttestationSchema.parse({
        kind: "bundle_release_v1",
        component: input.component,
        releaseSha,
        targetName,
        executionLane: input.executionLane,
        manifestSha256: input.manifestSha256,
        deployedAtMs,
    });
    if (parsed.executionLane !== `candidate:${parsed.releaseSha}`) {
        throw new Error("Candidate component release does not match its execution lane.");
    }
    if (parsed.targetName !== input.expectedTargetName) {
        throw new Error("Candidate component release does not match its fleet target.");
    }
    return parsed;
}
